import { call } from '../core'

/**
 * IYearMonthParams
 *
 * year: 화면에 보여질 년도의 초기값 (ex. 2019), 0으로 넘기면 현재 년도를 default로 사용
 * month: 화면에 보여질 월의 초기값 (1~12), 0으로 넘기면 현재 월을 default로 사용
 */
export interface IYearMonthParams {
  year: number
  month: number
}

export interface IYearMonthInfo {
  year: number
  month: number
}

export interface IYearMonthInfoResult {
  result: IYearMonthInfo | null
}

export function getYearMonth(params: IYearMonthParams): Promise<IYearMonthInfoResult | Error> {
  return call('finGetYearMonth', params)
}
